import ApiConfig from "../../Utils/Configs/apiConfig";
import { mapClientOverviewToCards } from "./overview.mapper";
import { MOCK_CLIENT_OVERVIEW_SECTIONS } from "./overview.mock";
import { OverviewCard } from "./overview.types";

export type { OverviewCard } from "./overview.types";

const mockOverviewCards = (): OverviewCard[] =>
  mapClientOverviewToCards(MOCK_CLIENT_OVERVIEW_SECTIONS);

export const getOverviewDocumentTypes = async (
  selectedClientId: string | null,
): Promise<OverviewCard[]> => {
  if (!selectedClientId) {
    return [];
  }

  try {
    const response = await ApiConfig.getInstance().get(
      `/BusinessClient/get-client-overview/${selectedClientId}`,
    );

    const sections = response.data?.data;
    if (!Array.isArray(sections) || sections.length === 0) {
      return mockOverviewCards();
    }

    return mapClientOverviewToCards(sections);
  } catch (error) {
    console.error("Error fetching overview document types:", error);
    return mockOverviewCards();
  }
};
